import {
    IonCard,
    IonCardContent,
    IonCol,
    IonLabel,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { Barn } from "../../models";
import QuickAddBarnForm from "./QuickAddBarnForm";
import SelectBarn from "./SelectBarn";
import { useHistory } from "react-router";

interface _Props {
    useAllBarns?: Boolean
    useSpecificBarns?: (Barn[] | null | undefined)
    barn?: (Barn | null)
    label?: (string | null)
    onChange: Function
}

const BarnEntryForm: React.FC<_Props> = ({useAllBarns, useSpecificBarns, barn, label, onChange}) => {
    const history = useHistory();

    const [selectedBarn, setSelectedBarn] = useState<Barn | null | undefined>(barn);
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        if (barn) {
            setSelectedBarn(barn);
        }
    }, [barn]);

    const handleBarnSelect = (barn: Barn) => {
        setSelectedBarn(barn);
        onChange(barn);
    }

    const handleNagivateToFindBarnPage = () => {
        const path = "/index/barn/add/";
        history.push(path);
    }

    return (
        <>
            <IonRow>
                <IonCol sizeXs="12" sizeMd="12">
                    <IonLabel position="stacked" color="dark">{label || "Barn"}</IonLabel>
                    <SelectBarn selectedValue={selectedBarn?.id} isClearable={true} useAllBarns={useAllBarns} useSpecificBarns={useSpecificBarns} onSelect={handleBarnSelect} />
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol size="6">
                    <p className="ion-text-right link" onClick={handleNagivateToFindBarnPage}>Join a New Barn</p>
                </IonCol>
                <IonCol size="6">
                    <p className="ion-text-left link" onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? "View Less" : (selectedBarn ? "Edit Barn" : "Create a New Barn")}</p>
                </IonCol>
            </IonRow>
            {isExpanded && (
                <IonCard color="white" className="ion-no-padding">
                    <IonCardContent className="ion-no-padding">
                        <QuickAddBarnForm selectedBarn={barn} onChange={handleBarnSelect}/>
                    </IonCardContent>
                </IonCard>
            )}
        </>
    );
};

export default BarnEntryForm;